import apiFetch from '../apiFetch'

export default function (idTipoInstalacionPadre, token) {
  return apiFetch({endPoint: `Combos/getComboInstalacionPadre`, method: 'POST', body: {idTipoInstalacionPadre}, token: token})
}